module.exports = {
  displayFontFamiliesEventCheckOnce: function () {
    return this.appBridge.version.isApp('webrand') || this.appBridge.version.isApp('pdf')
      || (!window.Android && this.appBridge.version.isGreaterThan('1.1.1'))
      || (window.Android && !this.appBridge.version.isLowerThan('1.1.3'));
  },

  displayFontFamiliesEvent: function (event) {
    var $fontFamily = this.$el.find('.fonts-list');

    this.appBridge.callBoth('pick_font', _.extend(this.getTextData('_'), {
      'position': _.extend($fontFamily.offset(), {
        height: $fontFamily.height(),
        width: $fontFamily.width()
      })
    }));

    $fontFamily.find('.ui-dropdown-items').removeAttr('style').hide();

    this.appBridge.off('ik.editor.text_update');
    this.appBridge.on('ik.editor.text_update', _.bind(function (event, data) {
      this.setTextData(data);
    }, this));
  }
};
